<script setup lang="ts">
import RoomieAccordion from '@lahaus-roomie/roomie/src/components/RoomieAccordion/index.vue'
import type { WhoWeAreLaHausAboutUsComponentModule } from '@/components/BrandedV2/WhoWeAreLaHausAboutUs/types'
import './_index.scss'

defineProps<WhoWeAreLaHausAboutUsComponentModule.Props>()
const { t, tm, rt } = useI18n()
const { $useLhId } = useNuxtApp()
const faqs: {title: string; content: string}[] = tm('faqs')

</script>

<script lang="ts">
export default {
  name: 'WhoWeAreLaHausAboutUs'
}
</script>

<template>
  <div class="py-56 lg:py-90 px-24 lg:px-90 text-pine-600">
    <div class="max-w-screen-lg mx-auto flex flex-col justify-center items-center">
      <div class="flex justify-center mb-16 lg:mb-24">
        <div class="bg-lime-600 body-2-sb lg:body-1-sb px-16 py-8 rounded-[6px]">
          {{ t('tag') }}
        </div>
      </div>

      <h2 class="max-w-[600px] display-6 lg:display-4 text-center mb-40 lg:mb-56">
        {{ t('title') }}
      </h2>

      <div class="w-full who-we-are-faqs-toggle-accordion-section flex flex-col gap-16">
        <RoomieAccordion
          v-for="(faq, index) in faqs"
          :id="`who-we-are-faqs-toggle-accordion-${index + 1}`"
          :key="index"
          class="who-we-are-faqs-toggle-accordion"
          :is-initially-open="false"
          :title="rt(faq.title)"
          :tracking-lh-id="$useLhId({ ...dataAttributes.dataLh, C: rt(faq.title), I: index })">
          <template #content>
            <p
              v-sanitize="rt(faq.content)"
              class="body-2-m lg:body-1-m" />
          </template>
        </RoomieAccordion>
      </div>
    </div>
  </div>
</template>

<i18n src="./i18n.json" lang="json"></i18n>
